import { Routes, Route, Navigate } from 'react-router-dom'
import { DocumentTextIcon, ExclamationCircleIcon, QueueListIcon, SignalIcon } from '@heroicons/react/24/outline'
import { RouteElement } from 'interfaces/_common'
import { SubMenuTabs } from '../common'
import RouteKeys from 'constants/route-keys'
import VideoTracking from './VideoTracking'
import VideoPlayerErrorLogs from './VideoPlayerErrorLogs'
import BufferLogs from './BufferLogs'
import WebhookInstrument from './WebhookInstrument'

const _routes: RouteElement[] = [
  {
    route: 'video-tracking-logger',
    title: 'Video Tracking',
    key: RouteKeys.VIDEO_TRACKING_LOGGER,
    component: VideoTracking,
    icon: DocumentTextIcon,
    display: true
  },
   {
    route: 'buffer-logs',
    title: 'Buffer Logs',
    key: RouteKeys.BUFFER_LOGS,
    component: BufferLogs,
    icon: QueueListIcon,
    display: true
  },
  {
    route: 'webhook-instrument',
    title: 'Webhook Instrument Log',
    key: RouteKeys.WEBHOOK_INSTRUMENT,
    component: WebhookInstrument,
    icon: SignalIcon,
    display: true
  },
  {
    route: 'player-error-logs',
    title: 'Video Player Error Logs',
    key: RouteKeys.PLAYER_ERROR_LOGS,
    component: VideoPlayerErrorLogs,
    icon: ExclamationCircleIcon,
    display: true
  },
]

const Logger = () => {
  return (
    <div>
      <SubMenuTabs _routes={_routes} />
      <div className="p-3">
        <Routes>
          <Route 
            path='' 
            element={<Navigate to={_routes[0].route} replace />} 
          />
          {_routes.map(route => (
            <Route 
              path={route.route} 
              key={'logger-' + route.route} 
              element={<route.component />} 
            />
          ))}
        </Routes>
      </div>
    </div>
  )
}

export default Logger
